export default __webpack_public_path__ + "static/media/sign-out.49d3e96f.svg";